import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, Tab, Tabs } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Proptypes from 'prop-types';
import { useState } from 'react';

import { api as stockApi } from '../../store/domains/stock';
// import IccidForm from '../common/IccidForm';
import IccidFileUpload from '../common/IccidFileUpload';
import IccidForm from '../common/IccidForm';
import IccidFormText from '../common/IccidFormText';
import Render from '../Render';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function IccidRangeDialog({ open, handleClose, isTransfer, isUnassign }) {
  const [value, setValue] = useState(0);
  const [selectValue, setSelectValue] = useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeSelect = (event) => {
    setSelectValue(event.target.value);
  };
  const { data: hubList, isLoading: hubListLoading } = stockApi.useGetHubList();

  if (hubListLoading) {
    return <CircularProgress />;
  }
  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose} fullWidth>
      {/* <DialogTitle>Assign to Diller</DialogTitle> */}
      <DialogContent>
        <Render shouldRender={!isUnassign}>
          <FormControl fullWidth>
            <InputLabel id="hub-label">Hub</InputLabel>
            <Select labelId="hub-label" id="hub" label="Hub" value={selectValue} onChange={handleChangeSelect}>
              {hubList?.map(({ hubId, title }) => (
                <MenuItem key={hubId} value={hubId}>
                  {title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Render>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Range" {...a11yProps(0)} />
            <Tab label="File" {...a11yProps(1)} />
            <Tab label="Text" {...a11yProps(2)} />
            {/* <Tab label="Write" {...a11yProps(2)} /> */}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <IccidForm hubId={selectValue} handleClose={handleClose} isTransfer={isTransfer} isUnassign={isUnassign} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <IccidFileUpload
            hubId={selectValue}
            handleClose={handleClose}
            isTransfer={isTransfer}
            isUnassign={isUnassign}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <IccidFormText
            hubId={selectValue}
            handleClose={handleClose}
            isTransfer={isTransfer}
            isUnassign={isUnassign}
          />
        </TabPanel>
        {/* <TabPanel value={value} index={2}>
          Item Three
        </TabPanel> */}
      </DialogContent>
    </Dialog>
  );
}

IccidRangeDialog.propTypes = {
  open: Proptypes.bool,
  handleClose: Proptypes.func,
  isTransfer: Proptypes.bool,
};

TabPanel.propTypes = {
  children: Proptypes.node,
  value: Proptypes.number,
  index: Proptypes.number,
};

export default IccidRangeDialog;
